import React from "react";
import { ReactComponent as CoinSvg } from "../../assets/icons/coin6.svg";

export default function CoinIcon({ size = 20, className = "" }) {
  const iconSize = typeof size === "number" ? `${size}px` : size;

  return (
    <CoinSvg
      className={className}
      aria-hidden="true"
      focusable="false"
      style={{
        width: iconSize,
        height: iconSize,
        display: "inline-block",
        verticalAlign: "-0.125em",
        flexShrink: 0,
      }}
    />
  );
}
